// extracted by mini-css-extract-plugin
module.exports = {"loader":"Search_loader__3iv9h"};